module.exports = __webpack_public_path__ + "img/4.a88f0e4f.png";